import React from "react";
import { Modal } from "antd";
import { URL_TANK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString } from "../../frameworks/Util";
import _ from "lodash";
import { TANK_ACTION, TANK_STATUS, TANK_STATUS_TH } from "../../constants/string";
import { POST } from "../../frameworks/HttpClient";

export default function StorageTankStatusLogModal(props) {
  const { open, onClose, target, onUpdate } = props;
  const [ errorMessage, setErrorMessage ] = React.useState();
  const tableRef = React.useRef();

  const columns = [
    {
      title: 'วัน - เวลา',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value),
      width: 180,
    },
    {
      title: 'หมายเหตุ', 
      dataIndex: '',
      key: 'note',
      render : (value, original) => {
        return original ? `${TANK_STATUS_TH[original.original_state] ?? 'แทงก์ว่าง'} -> ${TANK_STATUS_TH[original.new_state]}` : "-"
      }      
    },
    {
      title: 'Action', 
      dataIndex: '',
      key: 'action',
      render : (value, original, index) => {
        return index == 0 & original.new_state !== TANK_STATUS.FILLING ? <a onClick={() => handleRevert()}>ย้อนกลับ</a> : ''
      }      
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleRevert = async() => {
    try {
      await POST(`${URL_TANK.TANK_TRANSACTION}${target}/change-state/`, {action : TANK_ACTION.REVERT})
      onUpdate();
      refreshData();
    } catch (error) {
      setErrorMessage(error.errorMessage)
    }
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  React.useEffect(() => {
    setErrorMessage(null)
  },[open])

  return(
    <Modal
      title={<center>ประวัติเปลี่ยนสถานะ</center>}
      open={open}
      onCancel={onClose}
      width={600}
      destroyOnClose
      footer={[
        <>
        <ColorButton onClick={onClose}>ปิด</ColorButton>
        </>
      ]}
    >
      <ErrorMessages message={errorMessage}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TANK.TANK_TRANSACTION_STATUS_LOG}
        params={{tank_transaction : target}}
      />
    </Modal>
  )
}